import FetchByObjectConfig from '../Helpers/FetchByObjectConfig';

export const saveFoldersRequest = (filePath) => {    
    const config = {
        path: 'folders/folder',
        method: 'POST',
        body:{
            filePath
        }
    };
    return FetchByObjectConfig(config);
}


export const saveFilesRequest = (filename) => {    
    const config = {
        path: 'folders/filename',
        method: 'POST',
        body:{
            filename
        }
    };
    return FetchByObjectConfig(config);
}

export const getDataRequest = () => {    
    const config = {
        path: 'folders'
    };
    return FetchByObjectConfig(config);
}